import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Userwfd } from '../_models/userwfd.model';

@Injectable()
export class UserwfdService {
  constructor(private http: HttpClient) {}

  getAllUserwfds(): Observable<Userwfd[]> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<Userwfd[]>(
      'api/auth/users/find_wfd/',
      {},
      { headers: httpHeaders }
    );
  }

  findUserwfds(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<QueryResultsModel>(
      'api/auth/users/find_wfd/',
      queryParams,
      { headers: httpHeaders }
    );
  }

  getNoCodUsers(): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.get<any>('api/auth/users/nocod_users/', {
      headers: httpHeaders,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result);
    };
  }
}
